import React, { Component } from 'react';
import moment from 'moment';
import * as analytics from '../lib/analytics';
import { Text } from 'pp-react';
import getContent, { init } from 'react-i18n';

init({ contentNode: document.getElementById('data-messages') });
const i18n = getContent('app/components/liveStream');


const logos = [
  'https://www.paypalobjects.com/images/Cause/CampaignPage/Avatar_blue.svg',
  'https://www.paypalobjects.com/images/Cause/CampaignPage/Avatar_purple.svg',
  'https://www.paypalobjects.com/images/Cause/CampaignPage/avatar_orange.svg',
  'https://www.paypalobjects.com/images/Cause/CampaignPage/avatar_green.svg',
  'https://www.paypalobjects.com/images/Cause/CampaignPage/avatar_pink.svg',
];

const sizeLimit = 7;

export class liveStream extends Component {
  constructor(props) {
    super(props);
    this.renderContributions = this.renderContributions.bind(this);
  }

  handleAnalytics(npid) {
    analytics.trackLinkWithData(
      'charityLink',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  }

  renderContributions(contributions) {
    return (
      <div className={'live-stream'}>
        {contributions.map((contribution, index) => {
          const charity = contribution.charity || {};
          const charityUrl = `${this.props.coBrand}charity/${charity.npid}`;
          const logoUrl = charity.logo || logos[index % logos.length];
          let time = moment.utc(
            contribution.transaction_time || contribution.time_created
          );
          const now = moment();
          if (time.isAfter(now)) {
            time = now;
          }
          const timeAgo = time.fromNow();
          return (
            <div
              className={'feed'}
              key={index}
              style={{ position: 'relative' }}
            >
              <div style={{ clear: 'both' }}>
                <a href={charityUrl}>
                  <div
                    className={'transactionLogocontainer'}
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: 'white',
                    }}
                  >
                    <div style={{ margin: 'auto', position: 'relative' }}>
                      <div
                        className={'npo-avatar-container'}
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: 'white',
                        }}
                      >
                        <div
                          className={'npo-avatar'}
                          style={{
                            background: `url(${logoUrl}) no-repeat center, center`,
                            backgroundSize: 'contain',
                            width: '50px',
                            height: '50px',
                            margin: 'auto',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </a>
                <div className={'content'}>
                  <Text className={'line1'} size='md' as='p'>
                    {contribution.is_sharing_donor_info ? contribution.donor_name : i18n('label.anonymousDonor')}
                  </Text>
                  <Text
                    onClick={this.handleAnalytics.bind(this, charity.npid)}
                    className={'line2'}
                    size='sm'
                    as='p'
                  >
                    {i18n('label.contributor')} <a href={charityUrl}>{charity.name}</a>
                  </Text>
                  <Text className={'right'} size='sm' as='p'>
                    {timeAgo}
                  </Text>
                </div>
              </div>
              <hr className={'line-separator'} />
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const contributions = (this.props.contributions || []).slice(0, sizeLimit);
    return (
      <div>
        <div className={'panel'} style={{ height: '720px' }}>
          <Text size='xl3'>{i18n('title.liveStream')}</Text>
          {this.renderContributions(contributions)}
        </div>
      </div>
    );
  }
}

export default liveStream;
